import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=7b4e8e45&scoped=true&"
import script from "./prize.vue?vue&type=script&lang=ts&"
export * from "./prize.vue?vue&type=script&lang=ts&"
import style0 from "./prize.vue?vue&type=style&index=0&id=7b4e8e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e8e45",
  null
  
)

export default component.exports